
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';

@Component
export default class PaymentSettingsCard extends Vue {
  @Prop({ type: String, default: 'mdi-bank' }) readonly icon!: string;

  @Prop(Boolean) readonly expanded!: boolean;

  @Prop(Boolean) readonly inPlace!: boolean;

  localExpanded = false;

  get expandable() {
    return !!this.$scopedSlots.content;
  }

  get showBorder() {
    return !this.inPlace || this.localExpanded;
  }

  async mounted() {
    this.onPropExpanded(this.expanded);
    await this.$nextTick();
  }

  action() {
    if (this.expandable) {
      this.localExpanded = !this.localExpanded;
      this.$emit('update:expanded', this.localExpanded);
    }
    this.$emit('click');
  }

  @Watch('expanded')
  onPropExpanded(val: boolean) {
    this.localExpanded = val;
  }
}
